export default "__VITE_ASSET__C1G0Gxl0__"